// Google AdSense configuration
// To use specific ad units, fill in the slot IDs below.
// While slot IDs are empty, ads render in "auto" mode (Google decides placement/size).
export const ADSENSE_CLIENT = "ca-pub-6934299303065450";

export const ADSENSE_SLOTS: Record<string, string> = {
  "blog-in-article": "1142728296", // horizontal in-article (BlogPost)
  "blog-sidebar":    "4603673181", // rectangle sidebar (BlogSidebar)
  "brand-main":      "9439173258", // horizontal main column (BrandCouponsSection)
  "brand-sidebar":   "6813009913", // vertical sidebar (BrandCouponsSection)
};

export function getSlotId(key: string): string {
  return ADSENSE_SLOTS[key] || "";
}

let scriptLoaded = false;
let scriptLoading = false;

/**
 * Inject the AdSense script tag once. Idempotent and safe to call multiple times.
 * Should only be called after the user grants marketing consent (LGPD/GDPR).
 */
export function loadAdsenseScript(): void {
  if (typeof window === "undefined") return;
  if (scriptLoaded || scriptLoading) return;
  if (document.querySelector('script[data-adsense-loader="true"]')) {
    scriptLoaded = true;
    return;
  }
  scriptLoading = true;
  const s = document.createElement("script");
  s.async = true;
  s.crossOrigin = "anonymous";
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`;
  // Mark via dataset (used to dedupe). Avoid attributes the AdSense script
  // warns about (it treats unknown data-* on the head tag as suspicious).
  s.dataset.adsenseLoader = "true";
  s.onload = () => {
    scriptLoaded = true;
    scriptLoading = false;
  };
  s.onerror = () => {
    scriptLoading = false;
  };
  document.head.appendChild(s);
}

export function isAdsenseScriptLoaded(): boolean {
  if (typeof window === "undefined") return false;
  // @ts-ignore
  return scriptLoaded || !!window.adsbygoogle;
}
